<template>
  <div class="us_app">
    <section class="user_section">
      <article class="view cmnity">
        <div class="formula_title_wrap">
          <img src="@/assets/images/formula.png" alt="코끼리 비방사전" class="title_formula_img" />
        </div>
        <div class="search_box" style="flex-wrap: wrap">
          <p class="w100 mb20">
            총
            <strong> {{ scretPrescriptionList.length }} </strong>건
          </p>

          <div class="form_inline">
            <div class="flex items-center">
              <div class="form_select">
                <span class="mw80 fwb">카테고리</span>
                <b-form-select v-model="searchInfo.prescribe_category" style="width: 310px">
                  <b-form-select-option value="">선택</b-form-select-option>
                  <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                </b-form-select>
              </div>
              <span class="mw80 fwb ml20">비방명</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.prescribe_nm"
              />
            </div>
          </div>
          <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
          <div class="form_inline mt10">
            <div class="flex items-center">
              <span class="mw80 fwb">키워드</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.indications"
              />
              <span class="mw80 fwb ml20">등록자</span>
              <input
                type="text"
                class="form_control"
                placeholder="입력하세요."
                v-model="searchInfo.doctor_nm"
              />
            </div>            
          </div>
          <button class="btn btn_md btn_brown" @click="fn_move_mySecret">내비방관리 및 등록</button>
        </div>

        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <colgroup>
                  <col width="150" />
                  <col width="*" />
                  <col width="200" />
                  <col width="150" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>비방처방명</th>
                    <th>카테고리</th>
                    <th>적응중(처방 키워드)</th>
                    <th>출처</th>
                    <th>비방등록자</th>
                    <th>평점</th>
                    <th>😇</th>
                    <th>👿</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="scretPrescriptionList.length == 0">
                    <td colspan="9"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in scretPrescriptionList"
                    :key="index"
                    @click="fn_move_dtl_page(item)"
                  >
                    <td>
                      <span>{{ searchInfo.pageInfo.totPage - ( (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index}}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_category_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.indications }}</span>
                    </td>
                    <td>
                      <span>{{ item.prescribe_source }}</span>
                    </td>
                    <td>
                      <span>{{ item.nick_nm }}</span>
                    </td>
                    <td>
                      <StarRating :rating="item.avg_star_rating" />
                    </td>
                    <td>
                      <span>{{item.recommendCount}}</span>
                    </td>
                    <td>
                      <span>{{item.notRecommendCount}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import StarRating from "@/components/common/StarRating.vue";
import Pagination from "@/components/AdminPagination.vue"

export default {
  components: {
    Pagination,
    StarRating,
  },
  mixins: [commonUtil],
  data() {
    return {
      searchInfo : {
          doctor_nm : '',
          prescribe_nm : '',
          prescribe_category : '',
          indications : '',         
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }              
      },
      pagingShow : false,
      prescrbeCategoryList : [],
      scretPrescriptionList: [],
      selected: null,
    };
  },
  async created(){

    //검색정보 처리
    let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             

    if(searchInfoStore != null && searchInfoStore != {}){
        this.searchInfo = searchInfoStore;
    }

    //처방 카테고리
    this.prescrbeCategoryList = await this.getCode('GC00000015'); 
  },
  mounted(){
      this.fn_search();
  },
  methods : {
    fn_search(){

      this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

      console.log("@@@@@@@ this.searchInfo : %o",this.searchInfo);

      axios
          .post("/api/user/board/getScretPrescriptionList", this.searchInfo)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              this.scretPrescriptionList = res.data.scretPrescriptionList;

              this.searchInfo.pageInfo.totPage = res.data.totCnt;
              
              if(this.searchInfo.pageInfo.totPage> 0){
                  this.pagingShow = true;                          
              }                        

          })
          .catch((err) => console.log(err));
    },
    fn_movePage(page){
      this.searchInfo.pageInfo.page = page;
      this.fn_search();
    },
    fn_move_dtl_page(item){

        console.log("@@@@@@@ item : %o",item);
        this.$store.dispatch('detailSearchInfo/setSearchInfo', item);

      console.log("@@@@@@@ getSearchInfo : %o",this.$store.getters['detailSearchInfo/getSearchInfo']);



        this.$router.push({ name : 'ElepantSecretPrescriptionDetail'});
    },
    fn_move_mySecret(){
      this.$store.dispatch('detailSearchInfo/setSearchInfo', {});
      this.$router.push("/mypage/mySecretPrescriptionList");
    }
  }
};
</script>

<style scoped>
.formula_title_wrap {
  width: 100%;
  padding: 0 0 10px;
}
.title_formula_img {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
